import { IrappelResponse } from './Irappel';

export const responseRappelMensual: IrappelResponse = {
    current: {
        text: "Oro Plus", //Texto que aparece como categoría actual
        activations_text: "14 act",
        min_activations: 13, // se utiliza para mostrar el naranja de la barra, modificar si se quiere cambiar de categoria con los datos que hay en el master
        max_activations: 18, // se utiliza para mostrar el naranja de la barra, modificar si se quiere cambiar de categoria con los datos que hay en el master
        level_index: "copper", // si se cambia de categoria cambiarlo con lo que haya en level_index del master
        current_activations: 14, // activaciones del mes actual
        next_level:  {
            text: "Platino", //Texto de la categoria siguiente nivel
            activations_text: "19-35 act",
            min_activations: 19,
            max_activations: 35,
            level_index: "platinum"
        },
        are_there_activations_in_both_months: false
    },
    master: [
        {
            text: "Sin ventas",
            activations_text: "0 act",
            min_activations: 0,
            max_activations: 0,
            level_index: "uncategorized"
        },
        {
            text: "Bronce",
            activations_text: "1 act",
            min_activations: 1,
            max_activations: 1,
            level_index: "copper"
        },
        {
            text: "Plata",
            activations_text: "2-6 act",
            min_activations: 2,
            max_activations: 6,
            level_index: "silver"
        },
        {
            text: "Oro",
            activations_text: "7-12 act",
            min_activations: 7,
            max_activations: 12,
            level_index: "gold"
        },
        {
            text: "Oro Plus",
            activations_text: "13-18 act",
            min_activations: 13,
            max_activations: 18,
            level_index: "goldPlus"
        },
        {
            text: "Platino",
            activations_text: "19-35 act",
            min_activations: 19,
            max_activations: 35,
            level_index: "platinum"
        },
        {
            text: "Diamante",
            activations_text: "36 o +",
            min_activations: 36,
            max_activations: null,
            level_index: "diamond"
        }
    ],
    previous_month: {
        text: "Plata", //Se utiliza para saber la categoria del mes anterior
        activations_text: "2-6 act",
        min_activations: 2,
        max_activations: 6,
        level_index: "silver",
        current_activations: 4,
        next_level: {
            text: "Oro",
            activations_text: "7-12 act",
            min_activations: 7,
            max_activations: 12,
            level_index: "gold"
        }
    }
}


export const responseRappelBimensual: IrappelResponse = {
    current: {
        text: "Oro", //Texto que aparece como categoría actual
        activations_text: "14-25 act",
        min_activations: 4,
        max_activations: 13,
        level_index: "gold",
        current_activations: 20,
        activations_per_month: {
            january: 10, //activaciones que hubo en el mes de enero (1 mes del tramo)
            february: 10 // activaciones que hay en febrero (2 mes del tramo)
        },
        next_level: {
            text: "Oro Plus",
            activations_text: "26-37 act",
            min_activations: 26,
            max_activations: 37,
            level_index: "goldPlus"
        },
        are_there_activations_in_both_months: false
    },
    master: [
        {
            text: "Sin ventas",
            activations_text: "0-1 act",
            min_activations: 0,
            max_activations: 1,
            level_index: "uncategorized"
        },
        {
            text: "Bronce",
            activations_text: "2-3 act",
            min_activations: 2,
            max_activations: 3,
            level_index: "copper"
        },
        {
            text: "Plata",
            activations_text: "4-13 act",
            min_activations: 4,
            max_activations: 13,
            level_index: "silver"
        },
        {
            text: "Oro",
            activations_text: "14-25 act",
            min_activations: 14,
            max_activations: 25,
            level_index: "gold"
        },
        {
            text: "Oro Plus",
            activations_text: "26-37 act",
            min_activations: 26,
            max_activations: 37,
            level_index: "goldPlus"
        },
        {
            text: "Platino",
            activations_text: "38-71 act",
            min_activations: 38,
            max_activations: 71,
            level_index: "platinum"
        },
        {
            text: "Diamante",
            activations_text: "72 o +",
            min_activations: 72,
            max_activations: null,
            level_index: "diamond"
        }
    ],
    previous_month: {
        text: "Plata",
        activations_text: "4-13 act",
        min_activations: 4,
        max_activations: 13,
        level_index: "silver",
        current_activations: 4,
        next_level: {
            text: "Oro",
            activations_text: "14-25 act",
            min_activations: 14,
            max_activations: 25,
            level_index: "gold"
        }
    }
}
